import { useCallback } from 'react';
import { app, checkout } from 'core';
import { PAYMENT_PLAN_TYPE } from 'core/services/bff';
import { NotFoundCreditCardForm } from 'ui/components';
import { useRedirectToHome } from 'ui/hooks/useRedirectToHome';
import config from 'config';
import type { UIEvent } from 'react';

const NotFoundCreditCard = () => {
  const { trackClick } = app.commands.useAppCommand();
  const { setCreditCardOption } = checkout.commands.useCheckoutCommand();
  const { redirectToHome } = useRedirectToHome();
  const handleChangePayment = () => {
    setCreditCardOption({ paymentMode: PAYMENT_PLAN_TYPE.CREDIT_CARD });
    redirectToHome();
  };

  const handleClickToEudora = useCallback((event: UIEvent<HTMLButtonElement>) => {
    trackClick(event);
    window.location.href = config.app.fallbackUrl;
  }, []);

  return (
    <NotFoundCreditCardForm
      onClickChangePayment={handleChangePayment}
      onClickToHome={handleClickToEudora}
    />
  );
};

export default NotFoundCreditCard;
